module.exports = __webpack_public_path__ + "img/full-bond.95ea4c42.svg";